import {canCallApp, config} from '../utils';

const appHasCapability = async (capability) => {
  if (!config.app_version || !canCallApp('getCapabilities')) {
      return false
  }

  const capabilities = await getCapabilitiesDelay();
  if (!capabilities) return false;

  try {
    const response = JSON.parse(capabilities);
    if (!response || typeof response !== 'object' ||
        !(response.capabilities instanceof Array)) return false;

    return response.capabilities.includes(capability);
  } catch (e) {
    return false;
  }
};

const getCapabilitiesDelay = () => new Promise(resolve => setTimeout(() => // setTimeOut para esperar a que el webkit de IOS esté cargado
    resolve(Trendier.getCapabilities()), 1));

export {appHasCapability};
